import { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import { getConfig } from '@edx/frontend-platform';
import { sendPageEvent, sendTrackEvent } from '@edx/frontend-platform/analytics';
import { useIntl } from '@edx/frontend-platform/i18n';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

import ForgotPasswordEmailSent from './components/ForgotPasswordEmailSent';
import ForgotPasswordForm from './components/ForgotPasswordForm';
import { forgotPassword, setForgotPasswordFormData } from './data/actions';
import { forgotPasswordResultSelector } from './data/selectors';
import messages from './messages';
import Decorations from '../common-components/Decorations';
import { COMPLETE_STATE, DEFAULT_STATE, VALID_EMAIL_REGEX } from '../data/constants';

const ForgotPasswordPage = (props) => {
  const emailRegex = new RegExp(VALID_EMAIL_REGEX, 'i');
  const {
    status, submitState, emailValidationError,
  } = props;

  const { formatMessage } = useIntl();

  const [email, setEmail] = useState(props.email);
  const [validationError, setValidationError] = useState(emailValidationError);
  const [formSubmittedSuccessfully, setFormSubmittedSuccessfully] = useState(false);

  useEffect(() => {
    sendPageEvent('login_and_registration', 'reset');
    sendTrackEvent('edx.bi.password_reset_form.viewed', { category: 'user-engagement' });
  }, []);

  useEffect(() => {
    setValidationError(emailValidationError);
  }, [emailValidationError]);

  useEffect(() => {
    if (status === COMPLETE_STATE && !formSubmittedSuccessfully) {
      setFormSubmittedSuccessfully(true);
    }
  }, [formSubmittedSuccessfully, status]);

  const getValidationMessage = (value) => {
    let error = '';

    if (value === '') {
      error = formatMessage(messages['forgot.password.empty.email.field.error']);
    } else if (!emailRegex.test(value)) {
      error = formatMessage(messages['forgot.password.page.invalid.email.message']);
    }

    return error;
  };

  const handleBlur = () => {
    props.setForgotPasswordFormData({ email });
  };

  // const handleFocus = () => props.setForgotPasswordFormData({ emailValidationError: '' });

  const handleSubmit = (e) => {
    if (e) {
      e.preventDefault();
    }

    const error = getValidationMessage(email);
    if (error) {
      props.setForgotPasswordFormData({ email, emailValidationError: error });
    } else {
      props.forgotPassword(email);
    }
  };

  return (
    <>
      <Helmet>
        <title>{formatMessage(messages['forgot.password.page.title'],
          { siteName: getConfig().SITE_NAME })}
        </title>
      </Helmet>
      <div id="main-content" className="d-flex align-items-center flex-column flex-fill position-relative">
        {formSubmittedSuccessfully ? (
          <ForgotPasswordEmailSent
            email={email}
            submitState={submitState}
            handleSubmit={handleSubmit}
          />
        ) : (
          <ForgotPasswordForm
            email={email}
            setEmail={setEmail}
            validationError={validationError}
            handleBlur={handleBlur}
            submitState={submitState}
            handleSubmit={handleSubmit}
          />
        )}
        <Decorations />
      </div>
    </>
  );
};

ForgotPasswordPage.propTypes = {
  email: PropTypes.string,
  emailValidationError: PropTypes.string,
  forgotPassword: PropTypes.func.isRequired,
  setForgotPasswordFormData: PropTypes.func.isRequired,
  status: PropTypes.string,
  submitState: PropTypes.string,
};

ForgotPasswordPage.defaultProps = {
  email: '',
  emailValidationError: '',
  status: null,
  submitState: DEFAULT_STATE,
};

export default connect(
  forgotPasswordResultSelector,
  {
    forgotPassword,
    setForgotPasswordFormData,
  },
)(ForgotPasswordPage);
